import { Box, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SettingService } from 'services/SettingService';

const FreshDeskLogin: React.FC = () => {
  const [searchParams] = useSearchParams();

  // API Calls
  const fetchRedirectUrl = (state: string, nonce: string): void => {
    SettingService.freshDeskLogin({
      state,
      nonce,
    })
      .then((response) => {
        const { redirectUrl } = response.data;
        window.location.href = redirectUrl;
      })
      .catch(() => {
        // window.close();
      });
  };

  // Hooks
  useEffect(() => {
    if (searchParams.get('nonce') && searchParams.get('state')) {
      //   console.log();
      fetchRedirectUrl(searchParams.get('state')!, searchParams.get('nonce')!);
    }
  }, [searchParams]);

  // UI Elements
  return (
    <Box className="empty-content">
      <CircularProgress />
    </Box>
  );
};

export default FreshDeskLogin;
